let lendingFeeTypeOptions = [
  {
    label: '比率',
    value: 'Rate'
  },
  {
    label: '固定值',
    value: 'Amount'
  }
]

export default lendingFeeTypeOptions



// WEBPACK FOOTER //
// ./src/utils/lendingFeeTypeOptions.js